import React from "react"
import { Helmet } from "react-helmet"
import { graphql, Link } from "gatsby"
import { Layout } from "../../components/layout"
import { Categorie } from "../../data/formations/type"
import { FormationHeadGroup, categorieToStrPl } from "../../data/types/formations"
import { FormationHead } from "../../components/formations/FormationHead"

interface Props {
  data: {
    allFormations: {
      totalCount: number
      distinct: Categorie[]
      group: FormationHeadGroup[]
    }
  }
}

const ORDER = {
  CF: 0,
  CS: 1,
  CA: 2,
}

const Formations: React.FC<Props> = ({ data }) => (
  <Layout>
    <Helmet title="Formations 2025/2026" />
    <div className="container">
      <div className="row mt-3">
        <div className="col my-3">
          <h1>Formations 2025/2026</h1>
          <div className="card mb-3">
            <div className="card-body">
              <h5 className="card-title">Catalogue des formations</h5>
              {/* <p className="card-text">
                Le guide des formations FFTA 2024 est en cours d'élaboration. Il sera téléchargeable ici dès publication.
              </p> */}
              <p className="card-text">
                <a
                  className="btn btn-outline-primary btn-lg"
                  href="https://cloud.tiralarc-grand-est.fr/s/wtkEnoogaSXLEgy"
                  role="button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Catalogue des formations
                </a>
              </p>
            </div>
          </div>

          <div className="formations-container">
            {data.allFormations.group.filter(g => g.fieldValue != 'CS').sort((g1, g2) => ORDER[g1.fieldValue] - ORDER[g2.fieldValue]).map(group => (
              <div className="formations-group-container">
                <h3>
                  {categorieToStrPl(group.fieldValue)} <span className="badge badge-pill badge-secondary">{group.totalCount}</span>
                </h3>
                {group.nodes.map(formation => (
                  <FormationHead formation={formation} />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default Formations

export const pageQuery = graphql`
  query AllFormationsHeads {
    allFormations(sort: { fields: [reference], order: [ASC] }) {
      totalCount
      distinct(field: categorie)
      group(field: categorie) {
        totalCount
        fieldValue
        nodes {
          id
          url
          date(formatString: "DD/MM/YYYY", locale: "FR")
          titre
          reference
          categorie
          tags
          categories
          armes
          diplome
          age
        }
      }
    }
  }
`
